import { CAMPAIGNS, MEMBERS } from '../types'

export const AdminMembersReducer = (state = [], action) =>{
  const {type, payload} = action

  switch (type) {
    case MEMBERS: {
        const { data } = payload
        state = []
        return data
    }
    default: {
      return state
    }
  }
}
